module.exports = __webpack_public_path__ + "static/media/NEWSEVENTS3.bfb775f5.jpg";